SIGNING UP FOR SIPSIGNAL'S VOIP SERVICE CREATES A CONTRACT BETWEEN YOU AND US,
CONSISTING OF THE ORDER, THE APPLICABLE SERVICE DESCRIPTION AND THIS AGREEMENT.
ANY ONE OF THE FOLLOWING ACTIONS CONSTITUTES YOUR ACCEPTANCE AND AGREEMENT TO BE
BOUND BY THESE TERMS AND CONDITIONS: (1) ACCEPTING THE TERMS AND CONDITIONS
ELECTRONICALLY DURING THE ORDERING PROCESS AND/OR UPON LOGGING ON TO USE YOUR
SERVICE, (2) YOUR SUBMISSION OF AN ORDER, (3) YOUR USE OF THE SERVICE DESCRIBED
HEREIN. THROUGH THESE ACTIONS YOU ARE AGREEING TO BE BOUND BY THE TERMS OF THIS
AGREEMENT AND ALL TERMS AND CONDITIONS INCORPORATED BY REFERENCE IN THIS
AGREEMENT. <br /><br />
<section>
  <h2 class="legal__subtitle">INTRODUCTION.</h2>
  <br /><br />
  These SipSignal VOIP Service Terms and Conditions, together with any operating
  rules, policies, price schedules, or other supplemental documents expressly
  incorporated herein by reference and published from time to time
  (collectively, the “Agreement”), constitutes the entire agreement between
  SipSignal, Inc., an Arizona corporation (hereinafter referred to as “we,” “us”
  or “SipSignal”) and the party set forth in the related registration order form
  (hereinafter referred to as “you,” “user” or “Customer”) regarding SipSignal’s
  Service (as defined herein), and supersedes all prior agreements, discussions
  and writings between the parties regarding the subject matter of this
  Agreement. For purposes of this Agreement, the term “SipSignal” include our
  respective subsidiaries, affiliates, agents, employees, predecessors in
  interest, successors, attorneys and any other service provider that furnishes
  services or devices to you in connection with this agreement.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">2. DEFINITIONS.</h2>
  <br /><br />
  2.1 “Device” means a SipSignal-provided telephone, telephone adapter
  (“Adapter”), router, or other device used with the Services.
  <br /><br />
  2.2 “Documentation” means user manuals and other documentation relating to the
  Services, which are available to Customer by SipSignal accessible via the
  Internet or in the form of printed media.
  <br /><br />
  2.3 “Services” means the products and services that are being provided to you
  as described in any quote or order form, including, but not limited to,
  SipSignal’s Unified Communication services, collaboration services, and any
  associated software, hardware or web-based platform.
  <br /><br />
  “Service” shall also include any additional Services provided to you as
  described in any addendum or amendment.
  <br /><br />
  2.4 “Software” means any proprietary software owned by, licensed by, or which
  SipSignal has a right to sublicense under this Agreement, which software is
  either provided to Customer under this Agreement or is used in or used to
  provide the Services.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">3. REVISIONS TO TERMS AND PRICING.</h2>
  <br /><br />
  From time to time, we may revise the terms and conditions of this Agreement
  (including, without limitation, any of the policies incorporated by reference)
  and the pricing (except during the term of a Minimum Commitment Contract such
  as a SipSignal Service Agreement) for the Service. Notice of revisions to the
  Agreement or pricing shall be posted on the SipSignal Website (“the Website”)
  and deemed given and effective on the date posted to the Website. If you do
  not agree to the revision(s), you must terminate your Service immediately,
  subject to the Termination provisions provided in this Agreement. By
  continuing to use the Service after revision(s) are in effect, you hereby
  accept and agree to all such revisions.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">4. CUSTOMER REPRESENTATIONS.</h2>
  <br /><br />
  You represent and warrant that your primary residence or business address is
  in the United States. You represent and warrant that you are at least eighteen
  (18) years of age or, as applicable, the age of majority in the country, state
  or province in which you reside, and that you possess the legal right and
  ability to enter into this Agreement. You represent and warrant that your
  name, user name, contact information and registered location are true and
  correct and if for business use, you are authorized to act on behalf of your
  company. You understand that SipSignal relies on the information you supply
  and that providing false or incorrect information may result in Service
  provisioning and delivery delays, the suspension or termination of your
  Service and the inability of a 911- dialed call to be correctly routed to
  emergency service personnel, as further explained below. You agree to promptly
  notify SipSignal whenever your personal or billing information changes
  (including, but not limited to, your name, address, e-mail address, telephone
  number, and payment method, including credit card number and expiration date,
  if applicable). You agree to be financially responsible for your use of the
  Service as well as for use of your account by others.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">5. USE OF SERVICE AND DEVICE.</h2>
  <br /><br />
  5.1 Business Plans. Service is provided to you as a business user, for your
  business and home office use. This means that you are not using it for any
  personal, residential, nonbusiness and nonprofessional purpose. This also
  means that you are not to resell or transfer the Service to any other person
  for any purpose or make any charge for the use of the Service, without express
  written permission from SipSignal in advance. SipSignal reserves the right to
  immediately terminate, change the calling plan or modify the Service if
  SipSignal determines, in its sole discretion, that you are using the Service
  for non business or non-commercial use.
  <br /><br />
  5.2 Restrictions. You shall not: (a) copy or adapt the Software or the
  Services for any purpose, except as specifically permitted under this
  Agreement; (b) use the Software or Services except in accordance with all
  applicable laws and regulations, and except as set forth in the Documentation;
  (c) reverse engineer, translate, decompile, or disassemble the Software or
  Services; (d) use the Software or Services in any outsourcing, application
  service provider, time-sharing or service bureau arrangement, including,
  without limitation, any use to provide services or process data for the
  benefit of, or on behalf of, any third party other than the Customer; or (e)
  cause or permit the disabling or circumvention of any security mechanism
  contained in or associated with the Software or Services.
  <br /><br />
  5.3 Residential Plans. If you subscribe to our residential services, we
  provide you with the Service and the Device solely for residential use.
  SipSignal reserves the right to immediately terminate, change the calling plan
  or modify the Service if SipSignal determines, in its sole discretion, that
  you are using the Service for non residential use.
  <br /><br />
  5.4 User Responsibility. You agree that you are responsible for all use(s)
  related to your account. You understand this means that you accept full
  liability and responsibility for your actions or the actions of anyone who
  uses the Service via your account with or without your permission. You
  acknowledge that SipSignal will be sending you information, including your
  Password, via e-mail over the Internet. You agree that the Internet is not a
  secure network and that third parties may be able to intercept, access, use or
  corrupt the information and telephone calls you transmit over the Internet. In
  order to maintain the security of your Service, you should safeguard your User
  IDs and Passwords, as well as the media access control (MAC) address of the
  Adapter. The MAC address is one of the pieces of information used by SipSignal
  to authenticate customer calls and should not be shared.
  <br /><br />
  5.5 Use of Service and Device by Customers Outside the United States. While
  SipSignal encourages use of the Service within the United States to other
  countries, SipSignal does not presently offer or support the Service to
  customers located in any countries other than the United States. SipSignal’s
  Services are only for use by persons or entities whose primary residence or
  business address is in the United States. SipSignal’s Services are designed to
  work generally with unencumbered high-speed internet connections. However, if
  the high- speed internet connection you are using is outside the United States
  and/or your ISP places restrictions on the usage of VoIP services, SipSignal
  does not represent or warrant that use of the Service by you is permitted by
  any other jurisdictions or by any or all the ISPs. If you remove the Device to
  a country other than the United States or use the Service from there, you do
  so at its own risk, including the risk that such activity violates local laws
  in the country where you do so. You will be solely responsible for any
  violations of local laws and regulations or violations of ISP terms of service
  resulting from such use. You also agree to indemnify us for any claims,
  damages or expenses resulting from your use of the Services outside of the
  United States. SipSignal reserves the right to disconnect Services immediately
  if SipSignal determines, in its sole and absolute discretion, that you have
  used the Service or the Device in violation of applicable laws, including
  without limitation laws of jurisdictions outside the United States. You are
  solely liable for any and all use of the Service and/or Device by any person
  making use of the Service or Device provided to you.
  <br /><br />
  5.6 Account Ownership. The owner of the account under which the Services are
  ordered shall be the legal entity (e.g., corporation, partnership, individual)
  that signs up for the Services with SipSignal. If no legal entity is provided
  upon sign-up, the account owner shall be the owner of the credit card used to
  open such account, if applicable. Subsequent changes to ownership must be
  supported by appropriate legal documentation. SipSignal shall not adjudicate
  ownership-related disputes, or any other internal business dispute. If
  SipSignal is unable to determine the valid owner of the account, SipSignal
  reserves the right to suspend or terminate the account and Services.
  <br /><br />
  5.7. Unlimited Toll-Free Calling. Unlimited Toll-Free Calling is limited to
  receiving calls originating in the United States only.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">6.LOCAL NUMBER PORTABILITY.</h2>
  <br /><br />
  In the event you are transferring an existing phone number that currently is
  subscribed to another carrier, the following terms and conditions apply:
  <br /><br />
  6.1 Authorization. You hereby authorize SipSignal to process your order for
  the Service and to notify your local service provider of your decision to
  switch your local services to SipSignal and to transfer your telephone number,
  and represent that you are authorized to take these actions. You may be
  required to complete a letter of authorization, provide us with a copy of your
  most recent bill from your service provider, as well as provide us with any
  other information required by your service provider to port your number.
  Failure to provide any information requested by SipSignal or the third party
  services provider will delay the porting of the number to SipSignal. You
  acknowledge that the porting of your numbers is dependent upon the cooperation
  of you and third parties not under the control of SipSignal. SipSignal shall
  not be responsible for any delay in the port of your number and will not
  provide credit for any such delays.
  <br /><br />
  6.2 Activation. You agree and acknowledge that you must install and activate
  your Device prior to the date that the number switch becomes effective. You
  will be assigned a temporary telephone number until your transfer is
  completed. You may place and receive calls using this temporary number until
  such time as your phone number is transferred.
  <br /><br />
  6.3 Limitation. SipSignal has the right to refuse to import a number if, in
  its sole discretion, it does not have the infrastructure to support the
  number.
  <br /><br />
  6.4 Unauthorized Port Outs. You acknowledge and agree that telephone or
  facsimile numbers may be ported out from your Services or your account due to
  acts or omissions of third parties, and it may be difficult or impossible for
  SipSignal to: (i) prevent such port-outs: (ii) retrieve numbers ported-out of
  your account; or (iii) port such numbers back into your account. SipSignal has
  no responsibility or liability due to such port-outs.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">7.SERVICE DISTINCTIONS.</h2>
  <br /><br />
  You acknowledge and understand that the Service is not a telephone service,
  and we provide it on a best-efforts basis. Important distinctions exist
  between telephone service and the enhanced Service offering provided by
  SipSignal. The Service is subject to different regulatory treatment than
  telephone This treatment may limit or otherwise affect your rights of redress
  before Federal and State telecommunications regulatory agencies or judicial
  forums. Events beyond our control may affect our service, such as power
  outages, fluctuations in the internet, your underlying ISP or broadband
  service, or maintenance. We will act in good faith to minimize disruptions to
  your use of and access to our service.
  <br /><br />
  7.1 EMERGENCY SERVICES - 911 DIALING. You acknowledge and understand that
  SipSignal 911 dialing is different than traditional 911 service. See complete
  911 disclosure posted on our Web site, Legal Section.
  <br /><br />
  7.2 Operator Assisted Calling; May Not Support X11 Calling. You acknowledge
  and understand that the Service does not support 0+ or operator assisted
  calling, including, without limitation, collect calls, third party billing
  calls, 900, calling card calls or dial- around calls. Our Service may not
  support 311, 511, and other x11 services in one or more service areas.
  <br /><br />
  7.3 No Directory Listing. The phone numbers you get from us will not be listed
  in any telephone directories. However, any phone numbers you transfer from
  your local phone company may be listed.
  <br /><br />
  7.4 Incompatibility with Other Services.
  <br /><br />
  7.4.1 Non-Voice Equipment Limitations. You acknowledge and understand that the
  Service is not compatible with all non-voice communications equipment,
  including but not limited to, some home and office security systems that are
  set up to make automatic phone calls, emergency phones in elevators, some
  aspects of satellite TV systems, digital entertainment systems, fax machines,
  modems and medical monitoring devices. By accepting this Agreement, you waive
  any claim you may have against SipSignal for interference with or disruption
  of such systems due to the Service.
  <br /><br />
  7.4.2 Certain Broadband, Cable Modem, and Other Services. There may also be
  other services with which our Service may be incompatible. Some providers of
  broadband service may provide modems that prevent the transmission of
  communications using the Service. We do not warrant that the Service will be
  compatible with all broadband services and expressly disclaim any express or
  implied warranties regarding the compatibility of the Service with any
  particular broadband service.
  <br /><br />
  7.5 Use Outside of the United States. As previously noted there are
  limitations with the Service’s access to 911. SipSignal’s Service does not
  provide access to emergency services in any country outside of the United
  States. SipSignal disclaims any obligation to provide you with access to
  emergency services in any jurisdiction other than the United States.
  <br /><br />
  7.6 Substitution and Discontinuation of Services.. SipSignal may, in its sole
  discretion, discontinue or substitute any service, feature or functionality
  without your prior approval. If SipSignal discontinues a service, feature or
  functionality, or fails to substitute a service, feature or functionality with
  an equivalent service, feature or functionality, then upon your written
  request, SipSignal will reduce the fees assessed to your account by the amount
  that you specifically pay for any such discontinued or substituted service,
  feature or functionality.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">8.LENGTH OF SERVICE.</h2>
  <br /><br />
  8.1 Service Term. We provide the Service for the term that you have signed up
  for. Your term begins on the date you first ordered service (the “Subscription
  Date”). It is not the day you receive the Device you ordered or the first time
  you use the Service. You are purchasing the Service for the full service term
  as set forth in the Order.
  <br /><br />
  8.2 Automatic Renewal. The Service will automatically renew for subsequent
  terms of the same length as the initial term, excluding any promotional months
  or initial or renewal term extensions, unless you cancel your Service by
  providing SipSignal with notice as provided in Section 8.4 of this Agreement
  at least thirty (30) days before the end of the then-current service term.
  Each renewal term begins on the day after the last day of the previous term.
  Any and all fees assessed to your account during the initial term and any
  renewal terms will be charged to your payment method on file, which may
  include any payment method automatically updated by your issuing bank. If you
  are paying by credit card and your credit card is declined, invalid, or
  payment is not timely made by the issuer of your credit card, without further
  notice SipSignal reserves the right to automatically recharge the payment
  method until payment is received, the payment method is updated, or the
  Service is discontinued for nonpayment.
  <br /><br />
  8.3 Our right to disconnect. You understand and agree that SipSignal has the
  right to suspend, terminate or disconnect any part of Your Service generally
  at any time if:
  <br /><br />
  8.3.1 We determine or reasonably believe that You are violating, or violated,
  any applicable law;
  <br /><br />
  8.3.2 We determine or reasonably believe that You materially breached this
  Agreement;
  <br /><br />
  8.3.3 We determine or reasonably believe that You used fraudulent means to pay
  for the Services, including use of a fraudulent credit card;
  <br /><br />
  8.3.4 We determine or reasonably believe that You abused or harassed (verbally
  or otherwise) any SipSignal employee, contractor, agent or representative;
  <br /><br />
  8.3.5 We are ordered by law enforcement or other government agencies to
  suspend, terminate or disconnect your Services;
  <br /><br />
  8.3.6 You bring any legal action or proceeding against SipSignal, or
  participate in any class action lawsuit against SipSignal;
  <br /><br />
  8.3.7 A petition in bankruptcy is filed by or against You and such petition is
  not dismissed within thirty (30) days after the effective filing date thereof,
  or a trustee or receiver is appointed over You or Your material assets;
  <br /><br />
  8.3.8 We determine that such action is necessary to protect, maintain, or
  improve the Services, to prevent fraud or misrepresentation, to protect
  SipSignal, its customers or other third party SipSignal affiliates, or for any
  other good cause.
  <br /><br />
  8.3.9 It is otherwise contemplated by this Agreement.
  <br /><br />
  8.3.10 You fail to make payment.
  <br /><br />
  8.4 All charges owed at the time of disconnection will be immediately payable.
  We will pursue collection for unpaid amounts on disconnected accounts and may
  report these unpaid charges to credit bureaus.
  <br /><br />
  8.5 Termination of Service. In order to terminate the Service, contact our
  Customer Care Department, via email at service@SipSignal.com or by calling
  1-718-989-9833 prior to expiration of the current service term. Please refer
  to the SipSignal Cancellation Policy posted on our Web site at Legal Section.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">9. DEVICES.</h2>
  <br /><br />
  9.1 Ownership and Risk of Loss. You will own the Device and bear all the risk
  of loss, theft, or damage regardless of the payment schedule selected for
  Services and Devices. Minimum Commitment Contracts for Services and Devices
  may include early termination fees. Returns of non-defective Devices outside
  of the initial 30 day money back guarantee period will not be accepted. Refer
  to the Cancellation policy for more information.
  <br /><br />
  9.2 Rented Devices. For the purposes of this section "Rented Devices" means
  any Device leased to Customer by SipSignal or SipSignal agents or any other
  third-party with or without a separate charge or fee in connection with the
  Services.
  <br /><br />
  9.3 Section 9.1 above will not apply to Rented Devices. Unless otherwise
  agreed upon, Customer agrees that within thirty (30) days after the expiration
  of the Term of any Device Rental Agreement or termination of this Agreement,
  Customer will promptly return all Rented Devices to SipSignal. Customer will
  be responsible for (i) any damage to the Rented Devices as assessed by
  SipSignal upon receipt, (ii) the replacement cost of such Rented Devices if it
  is lost, misplaced, not delivered or stolen during transit, and (iii)
  shipping/handling costs.
  <br /><br />
  Customer agrees to pay the full retail cost for the repair or replacement of
  any Rented Device or part that is lost, stolen, damaged, modified, sold,
  transferred, leased, encumbered or assigned together with any costs incurred
  by SipSignal in obtaining or attempting to obtain possession of any Rented
  Devices.
  <br /><br />
  9.4 Promotional Devices. Devices included in a service offering at no charge
  may be previously used equipment. Unless otherwise provided in a Minimum
  Commitment Contract, Devices not returned upon cancellation of the Service
  will be charged to the customer. See Cancellation policy for details.
  <br /><br />
  9.5 Replacement of a Defective Device. Devices purchased from SipSignal will
  be covered by their respective factory warranties, if any, only. SipSignal
  does not offer any warranty in addition to, or in replacement of any factory
  warranties. If a factory warranty applies, then prior to returning the
  equipment, you must contact SipSignal at support@sipsignal.com so that
  SipSignal may determine whether a defect exists and to receive an RMA number,
  which is required along with the return. You must ship the equipment to the
  manufacturer at the address provided by SipSignal in accordance with all RMA
  procedures. You have 7 days after receipt of an RMA to ship the equipment back
  to the manufacturer at the address we provide. You must pay all shipping fees.
  Once the manufacturer has received the equipment, a replacement will be sent
  to you in accordance with the factory warranty, if any. If an advance
  replacement is provided and the factory has not received the defective Device
  within 14 days or it was not in a returnable condition, (original carton, all
  packing materials and parts in the same condition in which you received them),
  then SipSignal will charge you for the second device or for the missing parts.
  <br /><br />
  9.6 of damaged Devices. If you receive cartons or Devices that are visibly
  damaged, you must note the damage on the carrier’s freight bill or receipt and
  keep a copy. You must also keep the original carton, all packing materials,
  and parts in the same condition in which you received them from the carrier.
  You must then contact our Customer Care Department immediately at
  support@sipsignal.com for return instruction.
  <br /><br />
  9.7 Tampering with the Device. You may not change the electronic serial number
  or equipment identifier of your Device or perform a factory reset of your
  Device without first getting our written consent.
  <br /><br />
  9.8 All Headset Sales Are Final. Headsets, earpieces, in-ear monitors,
  microphones and similar devices are not eligible for return or refund unless
  otherwise required by law. All purchases of these types of products are final
  and non-refundable.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">10. FEES AND CHARGES.</h2>
  <br /><br />
  10.1 We will publish fees and charges on our Web site. These fees and charges
  may change from time to time (except pricing will not change during the term
  of a Minimum Commitment Contract). New pricing will be effective the next day
  following posting to the Web site and may be applied to renewals of existing
  services. We may introduce new products and services at special introductory
  pricing. Introductory pricing will not be applied retroactively to existing
  services and may be applied for only limited periods of time. At our
  discretion, we may change introductory pricing. Certain service charges, such
  as Regulatory Recovery Fees, Universal Service Fund fees, and E911 fees, are
  subject to change from time to time and are applicable to ALL Customers
  regardless of a Minimum Commitment Contract.
  <br /><br />
  10.2 Billing increments. All billing policies are defined by the specific
  package the customer chooses. Please refer to the Web site for exact billing
  policies.
  <br /><br />
  10.3 Taxes. Taxes Customer is responsible for, and shall pay are any
  applicable federal, state, municipal, local or other governmental sales, use,
  excise, Universal Service Fees, value-added, personal property, public utility
  and other taxes, fees and charges now in force or enacted in the future, that
  arise from or as a result of Customer’s subscription or use or payment for the
  Service or a Device. Such amounts are in addition to payment for the Service
  or Device and will be billed to you. If Customer is exempt from payment of
  such taxes, you will provide SipSignal with an original government-issued
  certificate attesting to tax-exempt status. Tax exemption will only apply from
  and after the date SipSignal receives such certificate.
  <br /><br />
  10.4 211,311,511. We do not currently provide directory listing services at
  this time.
  <br /><br />
  10.5 Charges for Calls from Public Payphones. We reserve the right to charge
  you for any tolls or fees resulting from calls you receive from public
  payphones.
  <br /><br />
  10.6 Activation Fee. One-time activation fees and any other installation fees
  that may apply are specified on the Web site and vary by product and plan
  chosen.
  <br /><br />
  10.7 Regulatory Recovery Fee. A Regulatory Recovery Fee shall be charged
  monthly to offset costs incurred by SipSignal in complying with inquiries and
  obligations imposed by federal, state and municipal regulatory
  bodies/governments and the related legal and billing expenses. This fee is not
  a tax or charge required or assessed by any government. The Regulatory
  Recovery Fee may apply to every phone number assigned, including toll free and
  virtual numbers.
  <br /><br />
  10.8 Reinstatement Fee. Reinstating any service deactivated for non-payment of
  fees shall result in a reinstatement fee up to $25.
  <br /><br />
  10.9 Returned Check Fee. SipSignal may charge up to the maximum amount
  permitted by law if your banking institution dishonors or reverses a check,
  draft, or other payment.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">11. BILLING AND PAYMENT.</h2>
  <br /><br />
  11.1 Billing. We will charge you in advance for each term of service. If you
  have selected a free trial offering, we will commence charging you for the
  Service at the expiration of the free trial period, unless we are notified of
  the contrary. When you subscribe to the Service, you must give us a valid
  email address and a payment method that we accept. We reserve the right to
  stop accepting your payment method or your payments. You must advise us at
  once if your payment method expires, you close your account, your billing
  address changes, your email address changes, or your payment method is
  cancelled and replaced on account of loss or theft. Except for usage-based
  charges, we will bill in advance to your payment method all charges, fees,
  taxes, and surcharges for each service term. Fees may also include activation
  fees, porting fees, early termination fees ("ETF"), reinstatement fees, and
  returned check fees. We reserve the right to charge all fees to your payment
  method. We will bill monthly as due immediately usage-based charges and any
  other charges which we decide to bill as due immediately. Bills will be posted
  to the customer portal and emailed to the email address on record. Any payment
  not made when due may be subject to a late payment fee equivalent to the
  lesser of (i) one and a half percent (1.5%) per month; or (ii) the highest
  rate allowed by law. SipSignal’s acceptance of late or partial payments
  (regardless of how they are marked or designated (including without limitation
  as ‘Paid in Full’, ‘Accord and Satisfaction’, or similarly)) will not waive,
  limit, or prejudice in any way SipSignal’s rights to collect any amount due.
  SipSignal may terminate the Services and this Agreement for non-payment if any
  fees or charges are not paid within thirty (30) days of the due date.
  <br /><br />
  11.2 Payment. When you subscribe to the Service, you authorize us to collect
  from your payment method. This authorization will remain valid until thirty
  (30) days after you terminate our authority to charge your payment method.
  <br /><br />
  11.3 Collection. If we disconnect the Service, you will remain liable to us
  for all charges under this agreement and all the costs we incur to collect
  these charges, including, without limitation, collection costs and attorney’s
  fees. You also agree to pay any additional charges or fees applied to your
  billing account for any reason, including but not limited to, interest and
  charges due to insufficient credit.
  <br /><br />
  11.4 Notices. You understand that it is difficult for us to distinguish
  between credit and debit cards. You agree to waive your rights under
  Regulation E to receive ten (10) days advance notice from us regarding the
  amount that we will debit from your account. While we may send you messages
  about your billing from time to time, we are not obligated to do so. We may
  change or cease our messages at any time without notice to you.
  <br /><br />
  11.5 Billing Disputes. You must notify SipSignal in writing within seven (7)
  days after receiving your credit card statement or from the time funds are
  debited from your bank account if you dispute any SipSignal charges on that
  statement or that have been debited from your account, or such dispute will be
  deemed waived. Notification of all billing disputes shall be sent to the
  following address: billing@sipsignal.com. SipSignal will charge a late fee as
  described in Section 11.1 for a disputed amount if (1) it was not paid by the
  due date and (2) SipSignal determines that you disputed the charge in bad
  faith.
  <br /><br />
  11.6 Prepaid Services. All prepaid fees being provided to you as described in
  any quote or order form and other payments by you under this Agreement are
  non-refundable and non-creditable.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">12. PRICING AND PAYMENT.</h2>
  <br /><br />
  12.1 Prices and Fees. SipSignal fees and charges for the Service are supplied
  to you during the ordering process unless otherwise provided for in this
  Agreement. You agree to pay the applicable one-time and recurring charges. You
  further agree that any taxes and other charges, including but not limited to,
  account setup fees, Adapter fees, Device charges, shipping and handling and
  other nonrecurring charges will be charged to your payment method on file.
  Recurring charges will be billed and automatically charged to your payment
  method on file on the first day of every billing cycle. Your billing cycle
  will begin on the anniversary date of your subscription date as defined in
  section 8.1.
  <br /><br />
  12.2 YOU AGREE THAT WE MAY CHARGE YOUR CREDIT CARD (IF APPLICABLE) FOR ALL
  AMOUNTS DUE TO US WITHOUT ADDITIONAL NOTICE OR CONSENT. If you are paying with
  a credit card, you agree to provide a credit card and not a debit card. If
  your card is a combination credit card/debit card, you authorize us to use it
  as a credit card. If your issuing bank automatically provides us with an
  updated credit card, you agree that we may charge this new credit card for all
  amounts due to us without additional notice or consent. You also agree to
  indemnify us for any claims, damages or expenses resulting from providing a
  debit card instead of a credit card (if applicable). If your credit card is
  declined, is invalid or payment is not made by the issuer of your credit card
  at the time that a charge is attempted, you will not be able to use the
  Service until your account is paid in full.
  <br /><br />
  12.3 Credit Balance Account. Your credit balance account has been established
  to cover incidental charges on your account that are not covered by your
  subscription fee. For example, international calls, toll free charges,
  Directory Assistance calls and taxes related to these calls are automatically
  charged to your credit balance account. A certain credit limit will be set on
  your account based upon your service plan and credit history. When the balance
  of your credit account reaches the credit limit, your account will be unable
  to make additional calls until the balance is paid down. You can make payments
  to reduce your credit balance account at any time by contacting our Customer
  Care Department at 1-718-988-9833 or by email to
  <a href="mailto:support@sipsignal.com">support@sipsignal.com</a>. Any credit
  balance used as of your subscription renewal or monthly anniversary date will
  be charged to the payment method on file. <br /><br />
  12.4 Credit Terms. All Services provided to You and covered by the Agreement
  shall at all times be subject to credit approval or review by SipSignal. You
  will provide such credit information or assurance as is requested by SipSignal
  at any time. SipSignal, in its sole discretion and judgment, may discontinue
  credit at any time without notice or require a deposit.
  <br /><br />
  12.5 Discontinuation of Service for Nonpayment. The Service to you may be
  denied or discontinued without notice at any time in the event you fail to
  make payment, your credit card provider denies or discontinues providing
  credit to you for any reason, or you fail to provide us with a new credit card
  expiration date before the existing one expires. If your payment method fails
  for any reason during the ordering process, or any regular or monthly billing
  process, you will have 24 hours to provide SipSignal your payment method,
  including credit card information if applicable. If the payment method is not
  resolved within 48 hours, SipSignal will deactivate the Service. If your new
  payment method is approved within 24 hours, your calling plan and billing
  cycle will remain unchanged. We reserve the right to modify the per minute
  calling plan at any time. You agree to pay all charges owed to SipSignal,
  including but not limited to the reinstatement fee for reactivated services.
  In the event SipSignal utilizes a collection agency or resorts to legal action
  to recover monies due, you agree to reimburse us for all expenses incurred to
  recover such monies, including attorneys' fees.
  <br /><br />
  12.6 Promotions. SipSignal may limit the number of promotions you may be
  eligible for in a given period. Promotions may be cancelled by SipSignal at
  any time.
  <br /><br />
  12.7 Cancellation Policy.SipSignal cancellation policies are outlined in the
  Cancellation Policy posted at our Web site at Legal Section and are
  incorporated into this policy with this reference. All cancellation requests
  must be submitted in the form of an email ticket to service@sipsignal.com or
  by calling our Customer Care Department at 1-718-989-9833 and must be made
  prior to the expiration of the Service term. See the cancellation policy for
  details. Changes to the Cancellation Policy may be made at any time without
  notice to you and is effective the day following posting to our Web site.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">13. MANAGEMENT OF YOUR DATA AND COMPUTER.</h2>
  <br /><br />
  13.1 System Management and Service Performance. You are solely responsible for
  obtaining, installing, configuring and maintaining suitable equipment,
  including your computer and telephone and software, including any necessary
  system or software upgrades, patches or other fixes which are or may become
  necessary to access the Service and to operate your computer. SipSignal will
  only provide technical assistance with respect to your SipSignal-provided
  Adapter. 13.2 Monitoring of Network Performance. SipSignal automatically
  measures and monitors network performance. We also will access and record
  information about your computer's profile and settings and the installation of
  the Software in order to provide customized technical support. No adjustments
  to your computer settings will be made without your permission. You hereby
  consent to SipSignal's monitoring of your Internet connection and network
  performance, and the access to and adjustment of your computer settings, as
  set forth above, as they relate to the Service.
  <br /><br />
  13.3 Storage of User Information. SipSignal is not obligated to store Your
  communications logs, voicemails, faxes, e-mails, or other messages and does so
  only as a convenience to You. You agree that SipSignal has no responsibility
  or liability whatsoever for the deletion or failure to store any call log
  information, voicemails, faxes, e-mails, messages, and/or other communications
  maintained or transmitted by the Services. You acknowledge and agree that
  SipSignal may establish limits as to the size of communications that SipSignal
  transmits or stores and the duration for which SipSignal stores any
  communications.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">
    14. LIMITATION ON WARRANTIES, REMEDIES AND LIABILITY, INDEMNIFICATION.
  </h2>
  <br /><br />
  14.1 WARRANTIES.
  <br /><br />
  14.1.1 SipSignal MAKES NO EXPRESS OR IMPLIED WARRANTY REGARDING THE SERVICE OR
  DEVICE OR THE INSTALLATION OF SAME AND DISCLAIMS ANY IMPLIED WARRANTY,
  INCLUDING ANY WARRANTIES OF MERCHANTABILITY AND/OR FITNESS FOR A PARTICULAR
  PURPOSE. SipSignal DOES NOT WARRANT THAT THE SERVICE OR DEVICE WILL FUNCTION
  WITHOUT FAILURE, DELAY, INTERRUPTION, ERROR, DEGRADATION OF VOICE QUALITY OR
  LOSS OF CONTENT, DATA OR INFORMATION. SipSignal DOES NOT AUTHORIZE ANYONE,
  INCLUDING BUT NOT LIMITED TO ITS EMPLOYEES, AGENTS OR REPRESENTATIVES, TO MAKE
  A WARRANTY OF ANY KIND ON ITS BEHALF AND YOU SHOULD NOT RELY ON ANY SUCH
  STATEMENT. CUSTOMER AGREES THAT IT ACCEPTS THE SERVICE AND DEVICE “AS IS” AND
  THAT CUSTOMER IS NOT ENTITLED TO REPLACEMENT OR REFUND IN THE EVENT OF ANY
  DEFECT. THE PROVISIONS OF THIS SECTION SHALL BE APPLIED TO THE FULLEST EXTENT
  OF THE LAW, BUT IF ANY PORTION OF THIS SECTION IS DETERMINED TO BE UNLAWFUL,
  THEN THIS SECTION SHALL BE CONSTRUED TO LIMIT LIABILITY AGAINST SipSignal TO
  THE FULLEST EXTENT POSSIBLE UNDER THE LAW.
  <br /><br />
  14.1.2 WE WILL NOT GIVE YOU CREDIT FOR ANY INTERRUPTION OF SipSignal SERVICE,
  INCLUDING INTERNATIONAL CALLING SERVICES.
  <br /><br />
  14.2 LIMITATION OF LIABILITY.
  <br /><br />
  14.2.1 IN NO EVENT SHALL SipSignal BE LIABLE TO YOU, YOUR REPRESENTATIVES OR
  AUTHORIZED ASSIGNS OR ANYONE ELSE FOR ANY INCIDENTAL, DIRECT, INDIRECT,
  SPECIAL, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL DAMAGES, OR FOR ANY DAMAGES FOR
  LOSS OF DATA, LOSS OF REVENUE OR PROFITS, RELATING TO OR ARISING OUT OF THE
  SERVICE, THE USE OF OR INABILITY TO USE THE SERVICE, THE ABSENCE, DELAY,
  FAILURE OR OUTAGE OF THE SERVICE, THE INABILITY TO DIAL 911 OR E911 TO ACCESS
  EMERGENCY SERVICE PERSONNEL, THE INABILITY TO DIAL SECURITY, LAW ENFORCEMENT
  OR FIRE PREVENTION/ PROTECTION SERVICES OR SYSTEMS, THE DEVICE, THE USE OF
  AND/OR INABILITY TO USE THE DEVICE, THE INSTALLATION OF THE DEVICE, AND/OR
  THIS AGREEMENT. NOR SHALL SipSignal BE LIABLE FOR ANY DELAY OR FAILURE TO
  PROVIDE THE SERVICE, INCLUDING 911 DIALING, AT ANY TIME OR FROM TIME TO TIME,
  OR FOR ANY INTERRUPTION OR DEGRADATION OF VOICE QUALITY CAUSED BY ANY REASON
  INCLUDING BUT NOT LIMITED TO THE FOLLOWING: AN ACT OR OMISSION OF AN
  UNDERLYING CARRIER, SERVICE PROVIDER, VENDOR OR THIRD PARTY, EQUIPMENT,
  NETWORK OR FACILITY FAILURE, EQUIPMENT, NETWORK OR FACILITY UPGRADE, SERVICE,
  MAINTENANCE, MODIFICATION, SHORTAGE, OR RELOCATION, FORCE MAJEURE EVENTS SUCH
  AS BUT NOT LIMITED TO ACTS OF GOD, ADVERSE WEATHER, STRIKES, FIRE, WAR, RIOT,
  GOVERNMENT ACTIONS OR TERRORISM, SERVICE, DEVICE, EQUIPMENT, NETWORK OR
  FACILITY FAILURE CAUSED BY THE LOSS OF POWER OR INTERNET SERVICE TO SipSignal
  OR CUSTOMER, AND ANY CAUSE THAT IS BEYOND SIPSIGNAL'S CONTROL, INCLUDING
  WITHOUT LIMITATION THE FAILURE OF AN INCOMING OR OUTGOING COMMUNICATION, THE
  INABILITY OF COMMUNICATIONS TO BE CONNECTED OR COMPLETED, INCLUDING 911
  DIALING, OR DEGRADATION OF VOICE QUALITY. SipSignal SHALL NOT BE LIABLE FOR
  UNAUTHORIZED ACCESS TO SIPSIGNAL'S OR CUSTOMER’S TRANSMISSION FACILITIES OR
  PREMISES, EQUIPMENT OR FOR UNAUTHORIZED ACCESS TO, OR ALTERATION, THEFT OR
  DESTRUCTION OF, CUSTOMER’S DATA FILES, PROGRAMS, PROCEDURES, OR INFORMATION
  THROUGH ACCIDENT, FRAUDULENT MEANS OR DEVICES OR ANY OTHER METHOD, REGARDLESS
  OF WHETHER SUCH DAMAGE OCCURS AS A RESULT OF SIPSIGNAL'S NEGLIGENCE OR OTHER
  ACTS OR OMISSIONS. SIPSIGNAL'S LIABILITY FOR ANY ACT OR OMISSION SHALL IN NO
  EVENT EXCEED THE SERVICE CHARGES WITH RESPECT TO THE AFFECTED TIME PERIOD. THE
  LIMITATIONS SET FORTH HEREIN APPLY TO ALL CLAIMS FOUNDED IN BREACH OF
  CONTRACT, BREACH OF WARRANTY, PRODUCT LIABILITY, TORT, AND ANY AND ALL OTHER
  THEORIES OF LIABILITY, AND APPLY WHETHER OR NOT SipSignal WAS INFORMED OF THE
  LIKELIHOOD OF ANY PARTICULAR TYPE OF DAMAGE. FURTHER, YOU AGREE TO REIMBURSE
  SipSignal FOR ALL COSTS AND EXPENSES RELATED TO THE DEFENSE OF ANY SUCH
  CLAIMS, INCLUDING ATTORNEYS’ FEES AND LITIGATION COSTS. THE PROVISIONS OF THIS
  SECTION SHALL BE APPLIED TO THE FULLEST EXTENT OF THE LAW, BUT IF ANY PORTION
  OF THIS SECTION IS DETERMINED TO BE UNLAWFUL, THEN THIS SECTION SHALL BE
  CONSTRUED TO LIMIT LIABILITY AGAINST SipSignal TO THE FULLEST EXTENT POSSIBLE
  UNDER THE LAW.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">15. INDEMNIFICATION AND WAIVER OF CLAIMS.</h2>
  <br /><br />
  15.1 INDEMNIFICATION.
  <br /><br />
  15.1.1 YOU ARE LIABLE FOR ANY AND ALL USE OF THE SERVICE AND/OR DEVICE BY
  YOURSELF AND BY ANY PERSON MAKING USE OF THE SERVICE OR DEVICE, AND YOU AGREE
  TO DEFEND, INDEMNIFY AND HOLD HARMLESS SipSignal AGAINST ANY AND ALL LIABILITY
  FOR ANY SUCH USE THAT FAILS TO COMPLY WITH THIS AGREEMENT. YOU AGREE TO
  DEFEND, INDEMNIFY AND HOLD HARMLESS SipSignal FROM ANY AND ALL CLAIMS AND/OR
  LIABILITY FOR DAMAGES, PERSONAL INJURY, DEATH, FINES, PENALTIES, COSTS,
  EXPENSES, LOSSES, LOST PROFIT, LOST REVENUE, PROPERTY DAMAGE, ATTORNEYS’ FEES,
  AND ANY AND ALL OTHER DAMAGES OF WHATEVER KIND AND NATURE RELATING TO OR
  ARISING OUT OF THE SERVICE, THE USE OF OR INABILITY TO USE THE SERVICE, THE
  ABSENCE, FAILURE OR OUTAGE OF THE SERVICE, THE INABILITY TO DIAL 911 OR E911
  TO ACCESS EMERGENCY SERVICE PERSONNEL, THE INABILITY TO DIAL SECURITY, LAW
  ENFORCEMENT OR FIRE PREVENTION/ PROTECTION SERVICES OR SYSTEMS, THE DEVICE,
  THE USE OF AND/OR INABILITY TO USE THE DEVICE, THE INSTALLATION OF THE DEVICE,
  AND/OR THIS AGREEMENT UNLESS THE CLAIMS OR CAUSES OF ACTION ARISE FROM OUR
  GROSS NEGLIGENCE, RECKLESSNESS, OR WILLFUL MISCONDUCT. THIS SECTION SHALL
  SURVIVE THE AGREEMENT.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">16. CONTENT.</h2>
  <br /><br />
  You are liable for all liability that may arise from the content you transmit
  to any person, whether or not you authorize it, using the Service or Device.
  You promise that you and anyone who uses the Service and all your and their
  content comply at all times with all laws, regulations, and written and
  electronic instructions for using the Service and the Device.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">17. MISCELLANEOUS LEGAL CONSIDERATIONS.</h2>
  <br /><br />
  17.1 Governing Law. This Agreement and the relationship between you and
  SipSignal shall be governed by the laws of New York without regard to its
  conflict of law provisions. Any claim brought pursuant to this Agreement shall
  be brought in a court of competent jurisdiction within the State of New York
  and venue for any such claim shall be proper in the appropriate state or
  federal court located in Nassau county, New York.
  <br /><br />
  17.2 No Waiver of Rights. Our failure to exercise or enforce any right or
  provision of this agreement will not constitute a waiver of the right or
  provision. SipSignal reserves all of its rights at law and equity to proceed
  against anyone who uses the Services or Device illegally or improperly. All
  determinations by SipSignal under this Agreement and exercise of its rights
  are made and done in our sole and absolute discretion.
  <br /><br />
  17.3 No Third Party Beneficiaries. If you are not a party to this Agreement,
  you do not have any remedy, claim, liability, reimbursement, or cause of
  action. This Agreement does not create any other third party beneficiary
  rights.
  <br /><br />
  17.4 Entire Agreement. This Agreement, the Order, the applicable service
  description or any reference herein to the content of SipSignal’s websites
  constitute the entire agreement between you and SipSignal and govern your use
  of the Service, superseding any prior agreements between you and SipSignal and
  any and all prior or contemporaneous statements, understandings, writings,
  commitments, or representations concerning its subject matter. No changes to
  this Agreement shall be binding upon either you or SipSignal unless they are
  agreed to in writing by both parties.
  <br /><br />
  17.5 Severability. If any part of this Agreement is legally declared invalid
  or unenforceable, all other parts of this Agreement will remain valid and
  enforceable. This invalidity or unenforceability will not invalidate or render
  unenforceable any other portion of this agreement.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">
    18. DISPUTE RESOLUTION AND BINDING ARBITRATION.
  </h2>
  <br /><br />
  18.1 It is important that you read this entire section carefully. This section
  provides for resolution of disputes through final and binding arbitration
  before a neutral arbitrator instead of in a court by a judge or jury. 18.2
  Arbitration. SipSignal and you agree to arbitrate any and all disputes and
  claims between you and SipSignal except with respect to claims for amounts
  owed for services rendered. Arbitration means that all disputes and claims
  will be resolved by a neutral arbitrator instead of by a judge or jury in a
  court. This agreement to arbitrate is intended to be given the broadest
  possible meaning under the law. It includes, but is not limited to: disputes
  and claims arising out of or relating to any aspect of the relationship
  between you and SipSignal, whether based in contract, tort, statute, fraud,
  misrepresentation or any other legal theory; disputes and claims that arose
  before this or any prior agreement (including, but not limited to, claims
  relating to advertising); disputes and claims that may arise after the
  termination of this agreement; disputes and claims that are currently the
  subject of individual litigation; disputes and claims that are currently the
  subject of purported class action litigation in which you are not a member of
  a certified class; and disputes and claims concerning the scope of this
  arbitration provision. References to “SipSignal,” “us” and “you” include our
  respective subsidiaries, affiliates, agents, employees, predecessors in
  interest, successors and assigns, as well as all authorized or unauthorized
  users or beneficiaries of the Service under this agreement or any prior
  agreements between you and SipSignal.
  <br /><br />
  18.3 Informal Resolution of Disputes. Our Customer Care Department can resolve
  most customer concerns quickly and to the customer’s satisfaction. If you have
  a dispute or claim against us, you should first contact the SipSignal Customer
  Care Department at 1-718-989-9833 and provide in detail, including documents
  or analysis supporting your position, the basis of your claim. Customer care
  shall be provided with 14 days in which to research and respond to your
  claim.. In the event your dispute or claim is not resolved to your
  satisfaction, you may seek to have that dispute or claim resolved as set forth
  below.
  <br /><br />
  18.4 Formal Notice of Disputes A party who intends to seek arbitration must
  first send to the other party a written “Notice of Dispute” setting forth in
  detail, including submission of supporting documentation, the grounds of your
  dispute. The Notice of Dispute to SipSignal must be sent to SipSignal,
  attention “General Counsel,” by certified mail addressed to 419 Windsor Place,
  Oceanside, NY 11572.
</section>
